export default __webpack_public_path__ + "static/media/JayBhalala_headshot.048a19c0.jpeg";